/**
 * Mirrors the backend rule: pricely-services closes a promotion once regClosingDate has
 * passed, and a nightly cron stamps response.promotionStatus. Check the raw date too, so a
 * promotion that expired since the last cron run already reads as closed here.
 *
 * Shared by the Campaigns list and the new-campaign alert so the two cannot disagree about
 * whether a seller can still participate.
 */
// eslint-disable-next-line import/prefer-default-export
export const isRegistrationClosed = (promotion) => {
  if (promotion?.response?.promotionStatus === 'Closed') return true;
  if (!promotion?.regClosingDate) return false;
  return new Date(promotion.regClosingDate) < new Date();
};
